"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateProjectRiskStatus = exports.getProjectRiskStatusChanges = exports.getActiveTeamsForProjectManagement = exports.getManagers = exports.getActions = exports.updateActions = exports.bulkSetProjectAndSegmentPriority = exports.updateSegmentPriority = exports.resetAssociateSegmentOrder = exports.updateAssociateSegmentOrder = exports.updateAssociateSegmentTarget = exports.updateRecruiterSegmentAssignment = exports.getSegments = exports.postComment = exports.updateAction = exports.getComments = exports.getAll = exports.getByAssociate = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var query_string_1 = tslib_1.__importDefault(require("query-string"));
function getByAssociate(_a) {
    var _b = _a.projectStatusId, projectStatusId = _b === void 0 ? 1 : _b, teamId = _a.teamId, organizationId = _a.organizationId, associateId = _a.associateId, sortBy = _a.sortBy, sortOrder = _a.sortOrder, projectId = _a.projectId, _c = _a.page, page = _c === void 0 ? 1 : _c, priorityId = _a.priorityId, priorityIds = _a.priorityIds, projectManagerId = _a.projectManagerId, userId = _a.userId;
    var queryParams = query_string_1.default.stringify({
        teamId: teamId || undefined,
        organizationId: organizationId || undefined,
        associateId: associateId || undefined,
        projectId: projectId || undefined,
        priorityId: priorityId || undefined,
        priorityIds: priorityIds || undefined,
        sortBy: sortBy || 'associateName',
        sortOrder: sortOrder || 'asc',
        projectStatusId: projectStatusId,
        projectManagerId: projectManagerId || undefined,
        page: page,
        userId: userId,
    }, { arrayFormat: 'comma' });
    return api_1.default.get("/api/project-management/by-associate?".concat(queryParams)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getByAssociate = getByAssociate;
function getAll(_a) {
    var actions = _a.actions, _b = _a.projectStatusId, projectStatusId = _b === void 0 ? 1 : _b, teamId = _a.teamId, sortBy = _a.sortBy, sortOrder = _a.sortOrder, projectId = _a.projectId, _c = _a.page, page = _c === void 0 ? 1 : _c, priorityId = _a.priorityId, priorityIds = _a.priorityIds, projectManagerId = _a.projectManagerId, userId = _a.userId;
    var queryParams = query_string_1.default.stringify({
        actions: actions,
        teamId: teamId || undefined,
        projectId: projectId || undefined,
        priorityId: priorityId || undefined,
        priorityIds: priorityIds || undefined,
        sortBy: sortBy || 'created_at',
        sortOrder: sortOrder || 'desc',
        projectStatusId: projectStatusId,
        projectManagerId: projectManagerId || undefined,
        page: page,
        userId: userId,
    }, { arrayFormat: 'comma' });
    return api_1.default.get("/api/project-management?".concat(queryParams)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getAll = getAll;
function getComments(id) {
    return api_1.default.get("/api/project-management/comments/".concat(id)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getComments = getComments;
function updateAction(_a) {
    var projectId = _a.projectId, priorityId = _a.priorityId, actionId = _a.actionId, extra1 = _a.extra1, extra2 = _a.extra2, extra3 = _a.extra3;
    return api_1.default
        .patch("/api/project-management/project/".concat(projectId), {
        priorityId: priorityId,
        actionId: actionId,
        extra1: extra1,
        extra2: extra2,
        extra3: extra3,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.updateAction = updateAction;
function postComment(projectId, comment) {
    return api_1.default.post("/api/note/project_management/".concat(projectId), { comment: comment }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.postComment = postComment;
function getSegments(projectId) {
    return api_1.default.get("/api/project-management/segments/".concat(projectId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getSegments = getSegments;
function updateRecruiterSegmentAssignment(projectId, employeeData) {
    return api_1.default.post("/api/project-management/segments/".concat(projectId), employeeData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.updateRecruiterSegmentAssignment = updateRecruiterSegmentAssignment;
function updateAssociateSegmentTarget(_a) {
    var projectId = _a.projectId, employeeId = _a.employeeId, segmentId = _a.segmentId, target = _a.target;
    return api_1.default
        .patch('/api/project-management/daily-target', { projectId: projectId, employeeId: employeeId, segmentId: segmentId, target: target })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.updateAssociateSegmentTarget = updateAssociateSegmentTarget;
function updateAssociateSegmentOrder(employeeId, orderedSegmentIds) {
    return api_1.default
        .patch("/api/project-management/by-associate/".concat(employeeId, "/segment-order"), { orderedSegmentIds: orderedSegmentIds })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.updateAssociateSegmentOrder = updateAssociateSegmentOrder;
function resetAssociateSegmentOrder(employeeId) {
    return api_1.default
        .delete("/api/project-management/by-associate/".concat(employeeId, "/segment-order"))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.resetAssociateSegmentOrder = resetAssociateSegmentOrder;
function updateSegmentPriority(_a) {
    var segmentId = _a.segmentId, priorityId = _a.priorityId;
    return api_1.default
        .patch('/api/project-management/segment-priority', { segmentId: segmentId, priorityId: priorityId })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.updateSegmentPriority = updateSegmentPriority;
function bulkSetProjectAndSegmentPriority(_a) {
    var projectId = _a.projectId, priorityId = _a.priorityId;
    return api_1.default
        .patch("/api/project-management/project/".concat(projectId, "/priority-bulk"), { priorityId: priorityId })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.bulkSetProjectAndSegmentPriority = bulkSetProjectAndSegmentPriority;
function updateActions(actions) {
    return api_1.default.post("/api/project-management/actions", actions).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.updateActions = updateActions;
function getActions(actions) {
    return api_1.default.get("/api/project-management/actions", actions).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getActions = getActions;
function getManagers() {
    return api_1.default.get("/api/project-management/managers").then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getManagers = getManagers;
function getActiveTeamsForProjectManagement() {
    return api_1.default.get("/api/project-management/active-teams").then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getActiveTeamsForProjectManagement = getActiveTeamsForProjectManagement;
function getProjectRiskStatusChanges(projectId) {
    return api_1.default.get("/api/project/".concat(projectId, "/risk-status-changes")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getProjectRiskStatusChanges = getProjectRiskStatusChanges;
function updateProjectRiskStatus(projectId, payload) {
    return api_1.default.post("/api/project/".concat(projectId, "/risk-status"), payload).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.updateProjectRiskStatus = updateProjectRiskStatus;
